import VisibleView from "components/hoc/VisibleView";
import { useAppContext } from "context/appContext";
import { WidgetProps } from "types";
import { TokenDonutChart, TokenStackedChart } from "./charts";
import ChartActionDropdown from "../ChartActionDropdown";
import { ChartSource, ChartType } from "constant/chart";

const getComponent = (source: ChartSource, chart: ChartType) => {
    if (chart === ChartType.DONUT && source === ChartSource.SUBSCRIPTION) {
        return TokenDonutChart;
    }

    if (
        chart === ChartType.STACKED_BAR &&
        source === ChartSource.SUBSCRIPTION
    ) {
        return TokenStackedChart;
    }

    return null;
};

const SubscriptionWidget = ({
    gatewaysConfig,
    zoomLevel,
    panel,
    panel: { source, chart },
    dashboardId,
    onDelete,
    allRegistry,
}: WidgetProps) => {
    const Component = getComponent(source, chart);
    const {
        storeData: {
            organization: { currentUserIsOwner },
        },
    } = useAppContext();

    return (
        <>
            {Component && (
                <div className="position-relative h-100">
                    {currentUserIsOwner && (
                        <ChartActionDropdown
                            panelId={panel.uuid}
                            dashboardId={dashboardId}
                            onDelete={onDelete}
                            panel={panel}
                        />
                    )}
                    <VisibleView>
                        <Component
                            gatewaysConfig={gatewaysConfig}
                            zoomLevel={zoomLevel}
                            panel={panel}
                            dashboardId={dashboardId}
                            onDelete={onDelete}
                            allRegistry={allRegistry}
                        />
                    </VisibleView>
                </div>
            )}
        </>
    );
};

export default SubscriptionWidget;
